module.exports = __webpack_public_path__ + "media/images/iphone-mock-black-79b66526a4dfd551fa5655368ec16564.png";